export const PUT_LOGIN_REQUEST = 'actions/login';
export const LOGIN_REQUEST = "loginRequest";
export const LOGIN_API = "login";
export const PUT_LOGOUT_REQUEST = 'actions/logout';
export const LOGOUT_REQUEST ="logoutRequest";
export const GET_SUB_DIRECTORIES = "actions/directories/getDirectoreies";
export const PUT_SUB_DIRECTORIES_REQUEST = "actions/directories/directoriesList";
export const DIRECTORY_PATH = '';
export const UPLOAD_FILES = 'actions/uploadfiles';
export const UPLOAD_PATH = 'upload'
export const MEDIA_FILE_UPLOADED_SUCCESSFULLY = "reducer/fileuploaded";
export const RESET_MEDIA_SUCCESS_MSG_STATE = "actions/resetmediamessage";
export const SUBMIT_USER_GROUP_DETAILS = "actions/submitusergroupdetails";
export const GET_DIRECTORIES_OPTIONS= "actions/getdirectoriesOptions";
export const GET_ACTIVEDIRECTORIES_USERS= "searchUsers";
export const GET_DIR_OPTIONS_LIST = "directories";
export const PUT_DIRECTORIES_OPTIONS = "statemanagement/updatedirectoryoptions";
export const PUSH_MEDIA_FILE_ACTION = "actions/pushfile";
export const PUSH_FUNC_API = "pushmediafile";
export const PUT_SUCCESS_LIVE_URLS = "update/state/production/urls";
export const EMPTY_MEDIA_SERVER_URLS = 'empty/mediaserver/urls';
export const GET_FILE_SMS_INFO = 'actions/getsmsfileinfo';
export const SMS_FILE_API = 'getsmsconfigfiledetails';
export const PUT_SMS_FILE_INFO = 'statemanagement/updatesmsinfo';
export const EMPTY_SMS_STATEMANAGEMENT_INFO = 'empty/sms/statemanagement';
export const ADD_SMS_INFO = 'actions/addsmsinfo';
export const SMS_CONFIG_API = 'smsconfig';
export const DELETE_SMS_INFO = 'actions/deletesmsinfo';
export const DELETE_SMS_CONFIG_API = 'deletesmsconfig';
export const GET_ACTIVE_DIRECTORY_USER = 'getactivedirectoryuser';
export const ACTIVE_USER_DIRECTORY_LIST = 'activeuserdirectorylist';
export const ADD_AD_USER = 'actions/addactivedirectoryuser';
export const ADD_USER_API = 'adduser';
export const GET_USER_LIST = 'actions/getuserlist';
export const GET_USER_LIST_API = 'userlist';
export const PUT_USER_LIST = 'statemanagement/userlist';
export const ENABLE_DISABLE_USER = 'enabledisableuser';
export const ENABLE_DISABLE_USER_API = 'disableuser';
export const DELETE_USER = 'actions/deleteUser';
export const DELETE_USER_API = 'deleteuser';
export const UNZIP_FOLDER = 'actions/unzip';
export const UNZIP_API = 'unzip';
export const USER_DISPLAY_MSG = 'usersuccessmessage';
export const EMPTY_GENERIC_SUCCESS_MESSAGE = 'emptygenericsuccessmessage';
export const CREATE_NEW_FOLDER_API = 'newfolder';
export const CREATE_NEW_FOLDER = 'actions/newfolder';
export const NO_DIR_USER_FOUND = 'actions/nodiroruserfound';
export const DELETE_SELECTED_FILES_LIST = 'actions/deleteselectedfiles';
export const DELETE_FILE_API = 'deletefile';
export const DELETED_ITEMS_API = 'deleted-items';
export const RESTORE_FILE_API = 'restorefile';
export const PUT_FILE_DELETE_INFO = 'statemanagement/deleteinfo';
export const RENAME_FOLDER = 'actions/rename';
export const RENAME_FOLDER_API = 'rename';
export const EDIT_USER_INFO = 'action/edituserinfo';
export const EDIT_USER_API = 'editUser';
export const EDIT_USER_DETAILS = 'statemanagement/edituserdetails';
export const UPDATE_USER_DETAILS = 'action/updateuser';
export const UPDATE_USER_API = 'updateuser';
export const BULK_DOWNLOAD_FILES = 'action/download';
export const BULKDOWNLOAD_FILE_API = 'download';
export const CLOSE_BULK_DOWNLOAD_POPUP = 'closeBulkDownloadPopup';
export const EMPTY_BULK_DOWNLOAD_POPUP_STATEMANAGEMENT_INFO = "resetBulkUploadStateManagement"
export const FILESCAN_ACCESS = "fileScanAccess"

// File and folder operations APIs
export const GET_FILESCAN_API = 'getfilescan';
export const FILE_UPLOAD_API = 'fileupload';
export const GET_FILE_SIZE_API = 'getFileSize';
export const FOLDER_METADATA_API = 'foldermetadata';
export const BULK_RENAME_API = 'bulkRename';
export const BULK_UPLOAD_API = 'bulkUpload';

// Search and navigation APIs
export const METASEARCH_API = 'metasearch';
export const INDEX_API = 'index';

// File scan and access APIs
export const FILESCAN_LIST_API = 'fileScanList';
export const FEED_USERS_API = 'feedusers';

// Runtime Config Admin APIs (proxied to media server via MSConsole backend)
export const RUNTIME_CONFIG_API = 'admin/runtime-config';

// Authentication flow APIs
export const LOGIN_ENDPOINT_API = 'login';
export const LOGOUT_ENDPOINT_API = 'logout';
export const LOGOUT_USER_API = 'logoutUser';

// Live URL Tracking admin APIs
export const LIVE_URL_TRACKINGS_API = 'admin/live-url-trackings';
export const LIVE_URL_TRACKINGS_STATS_API = 'admin/live-url-trackings/stats';

// Content Ownership Explorer (CCPL-8329) — lookup API (Phase 2+)
export const CONTENT_OWNERSHIP_API = 'admin/content-ownership';

/** Blocked in folder/file names: / \\ % + and space */
export const DISALLOWED_FILE_NAME_CHAR_REGEX = /[%+\/\\\x20]+/;
export const DISALLOWED_FILE_NAME_CHARS_GLOBAL = /[%+\/\\\x20]/g;
export const DISALLOWED_FILE_NAME_CHAR_MESSAGE =
  'Input must not contain spaces or some special characters.';

export const UPLOAD_FILENAME_SPACE_MESSAGE = 'Filename should not be with space';

export const UPLOAD_FILE_SPACE_MESSAGE =
  'This upload cannot proceed because one or more selected files have spaces in their names. Please rename the files to remove spaces and try again.';

export const UPLOAD_FOLDER_SPACE_MESSAGE =
  'This upload cannot proceed because one or more selected folders have spaces in their names. Please rename the folders to remove spaces and try again.';

export const UPLOAD_FILE_AND_FOLDER_SPACE_MESSAGE =
  'This upload cannot proceed because one or more selected files or folders have spaces in their names. Please remove spaces from all names and try again.';

export const UPLOAD_ZIP_FILENAME_SPACE_MESSAGE =
  'This ZIP file cannot be uploaded because the archive filename contains spaces. Please rename the ZIP file to remove spaces and try again.';

export const UPLOAD_ZIP_CONTENT_SPACE_MESSAGE =
  'This ZIP Folder cannot be uploaded because one or more files or folders inside the archive have spaces in their names. Please remove spaces from the File names in the ZIP folder and upload again.';

export const UPLOAD_ZIP_UNSAFE_MESSAGE =
  'This ZIP file could not be validated safely. Please use a smaller archive or re-create the ZIP and try again.';

export const UPLOAD_OVERSIZE_MESSAGE =
  'Files/Folders/ZIP size exceeds 5GB. Please select content less than 5GB to upload.';

export const UNZIP_OVERSIZE_MESSAGE =
  'ZIP size exceeds 5GB. Please unzip archives smaller than 5GB.';

export const PHP_DEPRECATION_EXTENSIONS = ['php', 'php3', 'php4', 'php5', 'php8', 'phtml', 'phps'];

export const PHP8_DESIGNATED_PATH_PREFIXES = ['php8'];

export const UPLOAD_PHP_RESTRICTION_MESSAGE =
  'This upload cannot proceed because one or more selected files contain restricted php4 or php5 content. Please upload PHP content only within the designated PHP8 folder and try again.';

export const UPLOAD_ZIP_CONTENT_PHP_RESTRICTION_MESSAGE =
  'This ZIP Folder cannot be uploaded because one or more files inside the archive contain restricted php4 or php5 content. Please upload PHP content only within the designated PHP8 folder and upload again.';

export const UPLOAD_PHP_AND_ZIP_RESTRICTION_MESSAGE =
  'This upload cannot proceed because one or more selected files and files inside the archive contain restricted php4 or php5 content. Please upload PHP content only within the designated PHP8 folder and try again.';

export const UPLOAD_ZIP_MANIFEST_REQUIRED_MESSAGE =
  'This ZIP Folder cannot be uploaded because the archive contents could not be validated. Please re-select the ZIP file and try again.';

export const UNZIP_PHP_RESTRICTION_MESSAGE =
  'This ZIP Folder cannot be unzipped because one or more files inside the archive contain restricted php4 or php5 content. Please upload PHP content only within the designated PHP8 folder.';

export const stripDisallowedFileNameChars = (input) =>
  String(input ?? '').replace(DISALLOWED_FILE_NAME_CHARS_GLOBAL, '');

/** True if this key event should be blocked (use with onKeyDown + preventDefault). */
export const shouldBlockFileNameKeyEvent = (e) =>
  e.code === ' ' ||
  e.key === '\x20' ||
  e.key === ' ' ||
  e.key === '%' ||
  e.key === '+' ||
  e.key === '/' ||
  e.key === '\\';

